import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from '@mui/material/styles';
import { theme } from "./styles/theme";

import { BrowserRouter } from "react-router-dom";

import { PublicClientApplication, EventType } from '@azure/msal-browser';

import App from './App';


export const msalConfig = {
  auth: {
        clientId: 'cd5fa906-4d49-4a41-a6b8-f81f9a6a7e41',
        redirectUri: 'https://outsidecounseldev.sanantonio.gov/',
        authority: 'https://login.microsoftonline.com/1ab0214f-ac4a-4407-a7c6-2ef1eb76dac5',
        postLogoutRedirectUri: 'https://outsidecounseldev.sanantonio.gov/',
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
};

export const loginRequest = {
    scopes: ["api://"+msalConfig.auth.clientId+"/access_as_user"] 
};

const pca = new PublicClientApplication(msalConfig);
  
  pca.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
      //  console.log('login success');
        pca.setActiveAccount(event.payload.account);
    } else if (event.eventType === EventType.LOGIN_FAILURE) {
      //  console.log('login failure');
    }
  });


  


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <App msalInstance={pca} />
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>
);
